<template>
    <v-form
        ref="refFormLogin"
        v-model="formLogin.valid"
        lazy-validation
        @submit.prevent="login"
        transition="slide-x-transition"
    >
        <v-card
            :loading="loading"
            outlined
            class="v-card--custom"
        >
            <v-card-text>
                <v-text-field
                    type="password"
                    name="password"
                    label="Password"
                    append-icon="lock"
                    v-model="formLogin.model.password"
                    :rules="formLogin.rules.password"
                    required
                ></v-text-field>
                <v-text-field
                    type="password"
                    name="newPassword"
                    label="New Password"
                    append-icon="lock"
                    v-model="formLogin.model.newPassword"
                    :rules="formLogin.rules.newPassword"
                    required
                ></v-text-field>
                <v-text-field
                    type="password"
                    name="confirmPassword"
                    label="Confirm Password"
                    append-icon="lock"
                    v-model="formLogin.model.confirmPassword"
                    :rules="formLogin.rules.confirmPassword"
                    required
                ></v-text-field>
            </v-card-text>

            <v-card-actions>

                <v-spacer></v-spacer>

                <v-btn
                    type="submit"
                    color="primary"
                    class="d-block d-sm-inline"
                    :loading="loading"
                    large
                    @click.prevent="registerNewPassword()"
                >Trocar Senha</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>

<script>
export default {
    name: 'form-login',
    props: ['loading'],
    vm: this,
    data: (vm) => ({
        formLogin: {
            valid: true,
            model: {
                password: '',
                newPassword: '',
                confirmPassword: ''
            },
            rules: {
                password: [
                    v => !!v || 'Password é obrigatório'
                ],
                newPassword: [
                    v => !!v || 'New Password é obrigatório'
                ],
                confirmPassword: [
                    v => !!v || 'Confirm Password é obrigatório',
                    (v) => {
                        return v === vm.formLogin.model.newPassword || 'Você precisa confirmar a Nova Senha'
                    }
                ]
            }
        }
    }),
    methods: {
        changeForm (boolean) {
            this.$emit('change-form', boolean)
        },
        registerNewPassword () {
            if (this.$refs.refFormLogin.validate()) {
                this.$emit('newPassword', this.formLogin.model)
            }
        }
    }
}
</script>
